<template>
    <div class="front-index" style="height: 100%;">
        <!-- 左侧菜单栏 -->
        <demoMenu></demoMenu>
        
        <!-- 右侧内容主体 -->
        <div class="page-right">
            <div class="page-right-top">
                <!-- 头像 and 菜单 -->
                <img class="info-icon" src='~assets/image/information.svg'>
                <z-lazyImg class="user-photo-nav"></z-lazyImg>
                <!-- <el-dropdown menu-align="start">
                    
                    <el-dropdown-menu slot="dropdown">
                        <el-dropdown-item v-if='code(2000)'>
                            <div @click="goSystem">系统管理</div>
                        </el-dropdown-item>
                        <el-dropdown-item>
                            <div @click="changeImg">上传头像</div>
                        </el-dropdown-item>
                        <el-dropdown-item>
                            <div @click="logout">退出登录</div>
                        </el-dropdown-item>
                    </el-dropdown-menu>
                </el-dropdown> -->
                <!-- <div class="right-top-search" v-if="showTopBarItem[5]">
                    <label class="icon-search"></label>
                    <input @keyup.enter="goSearch" v-model="keyword" type="text" autocomplete="off"
                           :placeholder="searchTip">
                </div> -->
            </div>

            <div class="main">
               <div class="demo-mask">
                   <img src="~assets/image/demo-group@2x.png">
                   <div class="front-btn green">立即开通</div>
               </div>
            </div>
        </div>

        <!-- <transition name="fade">
            <upAvatar :img="userInfo.userLogo" v-show="openAvatar"></upAvatar>
        </transition> -->   

    </div>
</template>

<script>
    import {mapState,mapGetters} from 'vuex'
    
    import demoMenu from './demoMenu.vue'
    // import upAvatar from './upAvatar.vue'

    // ****信息组件
    // import readInfo from 'src/components/info/read-info.vue';


    export default {
        components: {
            demoMenu,
            // upAvatar,
            // readInfo,
        },
        data () {
            return {
                // openAvatar:false,
            }
        },
        computed: {
            // ...mapState(['userInfo']),
            // ...mapGetters(['codeList']),
            // user_easy(){
            //     return {
            //         id:this.userInfo.id,
            //         company_id:this.userInfo.companyId,
            //         bu_id:this.userInfo.buId,
            //         real_name:this.userInfo.realName,
            //         type:'user',
            //     }
            // },
        },
        mounted(){
            // this.$func.getLink(this.user_easy);  //连接websocket 
            // this.$func.getCurrencyList(true);   //获取快币列表
        },

        methods: {
            // ******常规功能
            // logout() {  //退出登录
            //     this.$http.post('api/user/logout').then(res => {
            //         if (res.status == 200) {
            //             this.$func.logout();
            //             console.log(`跳链`)
            //             this.$router.push({name: 'login'});
            //         }
            //     });
            // },
            // goSystem() {
            //     this.$router.push({name: 'backhome'});
            // },
            // changeImg() {
            //     this.openAvatar = true;
            // },
            // code(val){  //验证权限
            //     return this.codeList.some(code=>code==val);
            // },
        },

    }
</script>

<style scoped lang="less">
    @import "~src/assets/less/var.less";

    .main{
        box-sizing: border-box;
        padding:@front_padd;
        height:calc(~"100% - @{front_head_h}");
        overflow: hidden;
        .demo-mask{
            background: #fff;
            height: 100%;
            position: relative;
            padding-top: 0.1px;
            text-align: center;
            @img_w:500px;
            @img_h:188px;
            img{
                height:@img_h;
                width:@img_w;
                display: block;
                position: absolute;
                top: 40%;
                left:50%;
                transform: translate(-50%,-50%);
            }
            .front-btn{
                position: absolute;
                top: calc(~"40% + @{img_h}/2 + 40px");
                width:96px;
                height:36px;
                line-height: 36px;
                font-size: 14px;
                border-radius: 4px;
            }
        }
    }

    .front-index{
        .clear();
    }

    .page-right{
        width:calc(~"100% - @{front_side_w}");
        height:100%;
        position:relative;
        float: left;
    }

    .page-right-top{
        height: @front_head_h;
        background: white;
        font-size: 0;
        position: relative;
        text-align: right;
        .align{  //信息提示位置调整
            position: absolute;
            right:75px;
        }
    }
    .page-right-top i{position: absolute;right: 0;top:0;display: inline-block;margin-top:15px;height: 30px;border-left: 1px solid #808080}
    .user-photo-nav{width: 36px;height: 36px;}

    .info-icon{
        display: inline-block;
        margin-right: 30px;
        vertical-align: top;
        position: relative;
        top:50%;
        transform: translateY(-50%);
    }
    .user-photo-nav{
        position: relative;
        display: inline-block;
        margin-right:37px;
        top:50%;
        transform: translateY(-50%);
    }
    // *********************

</style>



// WEBPACK FOOTER //
// page-demo.vue?0c5af9d8